import React, { Fragment, useRef, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import fontkit from "@pdf-lib/fontkit";
import { PDFDocument } from "pdf-lib";

import { db, storage } from "../../../../firebase";

import {
  orderBy,
  where,
  query,
  collection,
  and,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  setDoc,
} from "firebase/firestore";
import {
  ref,
  getDownloadURL,
  deleteObject,
  listAll,
  uploadBytes,
} from "firebase/storage";
import { Button, Modal } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import PageTitle from "../../../layouts/PageTitle";
import { usePagination } from "../../../../hook/usePagination";
import CpapTrialTicketItem, {
  formatServiceOrderNumber,
} from "./CpapTrialTicketItem";
import { CpapTrialTicketEditForm } from "./CpapTrialTicketEditForm";
import { CpapTrialExternalRepairForm } from "./CpapTrialExternalRepairForm";

const CpapTrialTicketList = (props) => {
  const { currentUser } = useAuth();
  const [isLoding, setIsLoading] = useState(false);
  const [isImageLoding, setIsImageLoding] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState({});
  const [searchItem, setSearchItem] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFilenames] = useState([]);

  // External repair modal states
  const [externalRepairModal, setExternalRepairModal] = useState(false);
  const [repairTicket, setRepairTicket] = useState(null);
  const externalRepairInputRef = useRef({
    vendor: "",
    sentDate: "",
    details: "",
    notes: "",
    repairStatus: "",
  });

  const searchRef = useRef(null);

  const [patientData, setPatientData] = useState({
    hn: "",
    brand: "",
    model: "",
    cpapType: "",
  });

  const inputRef = useRef({
    date: "",
    serviceType: "",
    sn: "",
    detail: "",
    accessories: "",
    description: "",
    image: "",
    receiveBy: "",
    serviceStatus: "",
    serviceDetail: "",
    completionDate: "",
    serviceBy: "",
  });

  const itemPerPage = 50;

  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "cpapTrialServiceTickets"),
    // The prefix changed from CTS to BD, so the raw order number no longer
    // sorts chronologically across old and new tickets.
    orderBy("createdAt", "desc")
  );

  if (searchItem !== "") {
    QueryFilterConstraint.push(
      where("sn", ">=", searchItem),
      where("sn", "<=", searchItem + "\uf8ff")
    );

    queryRef = query(
      collection(db, "cpapTrialServiceTickets"),
      and(...QueryFilterConstraint),
      orderBy("serviceOrderNumber", "desc")
    );
  }

  const {
    items: serviceTicketsList,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalItems,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: itemPerPage });

  const toggle = () => {
    setShowModal(!showModal);
  };

  const handleChange = (name) => (e) => {
    if (name === "image") {
      for (let i = 0; i < e.target.files.length; i++) {
        const f = e.target.files[i];
        setSelectedFiles((prevState) => [...prevState, f]);
        setFilenames((prevState) => [...prevState, f.name]);
      }
    }
    inputRef.current[name] = e.target.value;
  };

  const handleProductFound = (productData) => {
    setPatientData((prev) => ({
      ...prev,
      hn: productData.hn || "",
      brand: productData.brand || "",
      model: productData.model || "",
      cpapType: productData.cpapType || "",
    }));
  };

  const handleOnEdit = async (id) => {
    const data = serviceTicketsList.find((item) => item.id === id);

    // Reset inputRef to prevent value persistence from previous edits
    inputRef.current = {};

    setEdit(data);
    setShowModal(true);
  };

  const handleOnHide = () => {
    setShowModal(false);

    // Reset all state to prevent persistence
    inputRef.current = {};
    setSelectedFiles([]);
    setFilenames([]);
  };

  const handleOnDelete = (id, image) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteDoc(doc(db, "cpapTrialServiceTickets", id)).then(() => {
          // Delete files
          const storageRef = ref(storage, `cpapTrialServiceImage/${id}`);
          listAll(storageRef).then((res) => {
            const removeRef = res.items.filter((itemRef) =>
              image.includes(itemRef.name)
            );
            removeRef.forEach((res) => {
              const storageRef = ref(
                storage,
                `cpapTrialServiceImage/${id}/${res.name}`
              );
              deleteObject(storageRef, res.name);
            });
          });
          swal(`Poof! Your file has been deleted!`, {
            icon: "success",
          });
        });
      } else {
        swal("Canceled");
      }
    });
  };

  const onSearchChange = () => {
    setSearchItem(searchRef.current.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const docRef = doc(db, "cpapTrialServiceTickets", edit.id);
    const docSnap = await getDoc(docRef);

    let formData = {};
    if (docSnap.exists()) {
      formData = {
        date: "date" in inputRef.current ? inputRef.current.date : edit.date,
        serviceType: "serviceType" in inputRef.current ? inputRef.current.serviceType : edit.serviceType,
        sn: "sn" in inputRef.current ? inputRef.current.sn : edit.sn,
        accessories: "accessories" in inputRef.current ? inputRef.current.accessories : edit.accessories,
        description: "description" in inputRef.current ? inputRef.current.description : edit.description,
        image: fileNames.length > 0 ? fileNames : edit.image,
        receiveBy: "receiveBy" in inputRef.current ? inputRef.current.receiveBy : edit.receiveBy,
        serviceStatus: "serviceStatus" in inputRef.current ? inputRef.current.serviceStatus : edit.serviceStatus,
        serviceDetail: "serviceDetail" in inputRef.current ? inputRef.current.serviceDetail : edit.serviceDetail,
        completionDate: "completionDate" in inputRef.current ? inputRef.current.completionDate : edit.completionDate,
        serviceBy: "serviceBy" in inputRef.current ? inputRef.current.serviceBy : edit.serviceBy,
        amount: "amount" in inputRef.current ? inputRef.current.amount : edit.amount || "",
        note: "note" in inputRef.current ? inputRef.current.note : edit.note || "",
        updatedBy: currentUser.displayName,
        updatedAt: new Date(),
      };
    }

    await updateDoc(docRef, formData);

    // Update CPAP device status when ticket is completed or cancelled
    const resolvedStatus = "serviceStatus" in inputRef.current
      ? inputRef.current.serviceStatus
      : edit.serviceStatus;
    if (resolvedStatus === "เสร็จสิ้น" || resolvedStatus === "ยกเลิก") {
      const sn = "sn" in inputRef.current ? inputRef.current.sn : edit.sn;
      const cpapRef = doc(db, "cpaps", sn);
      const cpapSnap = await getDoc(cpapRef);
      if (cpapSnap.exists()) {
        await updateDoc(cpapRef, {
          Status: "ว่าง",
          Activity: resolvedStatus === "เสร็จสิ้น" ? "ส่งซ่อม(เสร็จสิ้น)" : "",
          UpdatedDateTime: new Date(),
        });
      }
    }

    if (fileNames.length > 0) {
      // Upload images
      const promises = [];
      selectedFiles.map((file) => {
        const storageRef = ref(
          storage,
          `cpapTrialServiceImage/${edit.id}/${file.name}`
        );
        const uploadTask = uploadBytes(storageRef, file);
        promises.push(uploadTask);
      });
      Promise.all(promises);
    }

    handleOnHide();
  };

  const handleOnViewFile = (id, file) => {
    setIsImageLoding(true);
    getDownloadURL(
      ref(storage, `cpapTrialServiceImage/${id}/${file}`)
    ).then((url) => {
      setFileUrl(url);
    });

    setIsImageLoding(false);
    setCreateModal(true);
  };

  const handleOnHideModal = () => {
    setCreateModal(false);
    setFileUrl(null);
  };

  // External Repair Number Generation
  async function getNextExternalRepairSequence() {
    const sequenceRef = doc(db, "sequenceTracker", "cpapTrialExternalRepairSequence");
    const sequenceDoc = await getDoc(sequenceRef);

    const currentDate = new Date();
    const thaiYear = currentDate.getFullYear() + 543;

    if (!sequenceDoc.exists()) {
      await setDoc(sequenceRef, { current: 1, year: thaiYear });
      return { sequence: "001", year: thaiYear.toString().slice(2) };
    }

    const data = sequenceDoc.data();
    let nextSequence;

    if (data.year !== thaiYear) {
      nextSequence = 1;
      await setDoc(sequenceRef, { current: 2, year: thaiYear });
    } else {
      nextSequence = data.current + 1;
      await updateDoc(sequenceRef, { current: nextSequence });
    }

    return {
      sequence: nextSequence.toString().padStart(3, "0"),
      year: thaiYear.toString().slice(2),
    };
  }

  async function generateExternalRepairNo() {
    const { sequence, year } = await getNextExternalRepairSequence();
    return "CTER" + year + sequence;
  }

  // External Repair handlers
  const handleOpenExternalRepair = (id) => {
    const ticket = serviceTicketsList.find((item) => item.id === id);
    setRepairTicket(ticket);
    const extRepair = ticket && ticket.externalRepair ? ticket.externalRepair : {};
    externalRepairInputRef.current = {
      vendor: extRepair.vendor || "",
      sentDate: extRepair.sentDate || "",
      details: extRepair.details || "",
      notes: extRepair.notes || "",
      repairStatus: extRepair.repairStatus || "",
    };
    setExternalRepairModal(true);
  };

  const handleExternalRepairChange = (name) => (e) => {
    externalRepairInputRef.current[name] = e.target.value;
  };

  const handleExternalRepairSubmit = async (e) => {
    e.preventDefault();

    if (!repairTicket) {
      swal("Error", "No ticket selected", "error");
      return;
    }

    if (!externalRepairInputRef.current.vendor) {
      swal("Error", "กรุณากรอกชื่อบริษัทที่ส่งซ่อม", "error");
      return;
    }
    if (!externalRepairInputRef.current.sentDate) {
      swal("Error", "กรุณากรอกวันที่ส่งบริษัทนอก", "error");
      return;
    }
    if (!externalRepairInputRef.current.repairStatus) {
      swal("Error", "กรุณาเลือกสถานะ", "error");
      return;
    }

    try {
      let externalRepairNo =
        repairTicket &&
        repairTicket.externalRepair &&
        repairTicket.externalRepair.externalRepairNo;
      if (!externalRepairNo) {
        externalRepairNo = await generateExternalRepairNo();
      }

      const repairData = {
        hasExternalRepair: true,
        externalRepair: {
          externalRepairNo: externalRepairNo,
          vendor: externalRepairInputRef.current.vendor,
          sentDate: externalRepairInputRef.current.sentDate,
          details: externalRepairInputRef.current.details || "",
          notes: externalRepairInputRef.current.notes || "",
          repairStatus: externalRepairInputRef.current.repairStatus,
          createdAt:
            (repairTicket &&
              repairTicket.externalRepair &&
              repairTicket.externalRepair.createdAt) ||
            new Date(),
          createdBy:
            (repairTicket &&
              repairTicket.externalRepair &&
              repairTicket.externalRepair.createdBy) ||
            currentUser.displayName,
          updatedAt: new Date(),
          updatedBy: currentUser.displayName,
        },
        serviceStatus: "ส่งซ่อมบริษัทนอก",
        updatedAt: new Date(),
        updatedBy: currentUser.displayName,
      };

      await updateDoc(
        doc(db, "cpapTrialServiceTickets", repairTicket.id),
        repairData
      );

      // Update CPAP device status
      const cpapRef = doc(db, "cpaps", repairTicket.sn);
      const cpapSnap = await getDoc(cpapRef);
      if (cpapSnap.exists()) {
        await updateDoc(cpapRef, {
          Status: "ไม่ว่าง",
          Activity: "ส่งซ่อม",
          UpdatedDateTime: new Date(),
        });
      }

      setExternalRepairModal(false);
      swal("Success", "บันทึกข้อมูลส่งซ่อมบริษัทนอกเรียบร้อย", "success");
    } catch (error) {
      console.error("Error saving external repair:", error);
      swal("Error", "Failed to save external repair data", "error");
    }
  };

  const handleCloseExternalRepairModal = () => {
    setExternalRepairModal(false);
    setRepairTicket(null);
    externalRepairInputRef.current = {
      vendor: "",
      sentDate: "",
      details: "",
      notes: "",
      repairStatus: "",
    };
  };

  const handleExportServiceTicket = async (ticketId) => {
    try {
      const ticket = serviceTicketsList.find((item) => item.id === ticketId);
      if (!ticket) {
        swal("Error", "Service ticket not found!", "error");
        return;
      }

      const serviceTemplateUrl = await getDownloadURL(
        ref(storage, "templates/F-501-018-A Service Request Form.pdf")
      );

      const existingPdfBytes = await fetch(serviceTemplateUrl).then((res) =>
        res.arrayBuffer()
      );
      const fontBytes = await fetch("./assets/fonts/Sarabun-Medium.ttf").then(
        (res) => res.arrayBuffer()
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      const firstPage = pdfDoc.getPages()[0];
      const { height } = firstPage.getSize();
      const patientName = [ticket.firstname, ticket.lastname]
        .filter(Boolean)
        .join(" ")
        .trim();

      firstPage.drawText(
        `${formatServiceOrderNumber(ticket.serviceOrderNumber) || "-"}`,
        {
          x: 400,
          y: height - 130,
          size: 10,
          font: customFont,
        }
      );

      if (ticket.date) {
        const serviceDate = ticket.date.toDate
          ? ticket.date.toDate()
          : new Date(ticket.date);
        firstPage.drawText(
          serviceDate.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
          {
            x: 400,
            y: height - 165,
            size: 10,
            font: customFont,
          }
        );
      }

      // Trial devices may not belong to a patient, so keep these customer
      // fields printable even when no patient record is attached.
      firstPage.drawText(`${ticket.hn || "-"}`, {
        x: 180,
        y: height - 130,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(patientName || "-", {
        x: 180,
        y: height - 147,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.mobile || "-"}`, {
        x: 180,
        y: height - 165,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.brand || ""}`, {
        x: 180,
        y: height - 198,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.model || ""}`, {
        x: 400,
        y: height - 198,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.sn || ""}`, {
        x: 180,
        y: height - 217,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.serviceType || ""}`, {
        x: 400,
        y: height - 147,
        size: 10,
        font: customFont,
      });

      if (ticket.description) {
        firstPage.drawText(`${ticket.description}`, {
          x: 100,
          y: height - 305,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      if (ticket.accessories) {
        firstPage.drawText(`${ticket.accessories}`, {
          x: 180,
          y: height - 235,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      firstPage.drawText(`${ticket.serviceStatus || ""}`, {
        x: 180,
        y: height - 662,
        size: 10,
        font: customFont,
      });

      if (ticket.serviceDetail) {
        firstPage.drawText(`${ticket.serviceDetail}`, {
          x: 100,
          y: height - 505,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      if (ticket.completionDate) {
        const completionDate = ticket.completionDate.toDate
          ? ticket.completionDate.toDate()
          : new Date(ticket.completionDate);
        firstPage.drawText(
          completionDate.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
          {
            x: 100,
            y: height - 677,
            size: 10,
            font: customFont,
          }
        );
      }

      const pdfDocBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfDocBytes], { type: "application/pdf" })
      );
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error exporting CPAP Trial service ticket PDF:", error);
      swal("Error", "Failed to export PDF. Please try again.", "error");
    }
  };

  return (
    <Fragment>
      <PageTitle
        activeMenu="CPAP Trial Maintenance List"
        motherMenu="CPAP Trial"
      />

      <Modal
        className="fade bd-example-modal-lg"
        show={showModal}
        onHide={toggle}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Ticket Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CpapTrialTicketEditForm
            onChange={handleChange}
            initailValues={edit}
            onProductFound={handleProductFound}
            fileNames={fileNames}
            defaultfiles={edit.image}
            ticketId={edit.ticketId}
            onViewFile={handleOnViewFile}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button className="sm ml-2" variant="light" onClick={handleOnHide}>
            Cancel
          </Button>
        </div>
      </Modal>

      {!isImageLoding && (
        <Modal
          className="fade bd-example-modal-lg"
          show={createModal}
          onHide={handleOnHideModal}
          size="xl"
          backdrop={true}
          keyboard={true}
          dialogClassName="modal-90w"
        >
          <Modal.Body className="m-0 p-0">
            <div
              className="card-body mx-0 p-0 col-sm-12"
              style={{ height: "80vh" }}
            >
              {fileUrl && (
                <img
                  src={fileUrl}
                  alt="Ticket Image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* External Repair Modal */}
      <Modal
        show={externalRepairModal}
        onHide={handleCloseExternalRepairModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>ส่งซ่อมบริษัทนอก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {repairTicket && (
            <div className="mb-3 p-3 bg-light rounded">
              <p className="mb-1">
                <strong>Service Order:</strong> {repairTicket.serviceOrderNumber}
              </p>
              <p className="mb-0">
                <strong>Equipment:</strong> {repairTicket.brand}{" "}
                {repairTicket.model} (SN: {repairTicket.sn})
              </p>
            </div>
          )}

          {repairTicket && repairTicket.serviceType && (
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">ประเภท</label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  value={repairTicket.serviceType}
                  disabled
                />
              </div>
            </div>
          )}

          {repairTicket && repairTicket.accessories && (
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">รายการอุปกรณ์</label>
              <div className="col-lg-6">
                <textarea
                  className="form-control"
                  value={repairTicket.accessories}
                  disabled
                  rows="2"
                />
              </div>
            </div>
          )}

          {repairTicket && repairTicket.image && repairTicket.image.length > 0 && (
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">รูปภาพ</label>
              <div className="col-lg-6">
                {repairTicket.image.map((img, idx) => (
                  <Link
                    key={idx}
                    to="#"
                    onClick={() => handleOnViewFile(repairTicket.id, img)}
                    className="mr-2 d-block"
                  >
                    <i className="fa fa-image"></i> {img}
                  </Link>
                ))}
              </div>
            </div>
          )}

          <CpapTrialExternalRepairForm
            onChange={handleExternalRepairChange}
            initialValues={repairTicket && repairTicket.externalRepair}
          />
        </Modal.Body>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleExternalRepairSubmit}>
            บันทึก
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleCloseExternalRepairModal}
          >
            ยกเลิก
          </Button>
        </div>
      </Modal>

      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Link
          to="/cpap-trial-service-create"
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Create Ticket"
        >
          + New Ticket
        </Link>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search serial number here"
            ref={searchRef}
            onChange={onSearchChange}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>

      <CpapTrialTicketItem
        tickets={serviceTicketsList}
        onEdit={handleOnEdit}
        onViewFile={handleOnViewFile}
        onDelete={handleOnDelete}
        onExportTicket={handleExportServiceTicket}
        onExternalRepair={handleOpenExternalRepair}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        itemsPerPage={itemPerPage}
        goToPage={goToPage}
        isStart={isStart}
        isEnd={isEnd}
        getNext={getNext}
        getPrev={getPrev}
      />
    </Fragment>
  );
};

export default CpapTrialTicketList;
